module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('quill-editor', {
    attrs: {
      "content": _vm.value,
      "options": _vm.options
    },
    on: {
      "change": _vm.onEditorChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430230c1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/richtext/richtext.vue
// module id = 549
// module chunks = 23